import { FormattedMessage } from "react-intl";
import styles from "./styles.module.scss";
import { Typography } from "@/shared/ui/Typography";
import { GRAY_COLOR } from "@/styles/colorsJS";

export const Licence = () => (
  <div className={styles.license}>
    <Typography as="p" type="caption" color={GRAY_COLOR}>
      <FormattedMessage defaultMessage="Лицензия АРРФР на осуществление микрофинансовой деятельности ТОО “MФО Legal Money” №05.22.0002.М. от 15.11.2022 года" />
    </Typography>
  </div>
);
